<template>
  <a-modal width="50%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <div v-if="formType==='margin' ">
      <p>保证金审核通过后,将创建商家管理员账号, (企业认证的登录账号为公司名称) (个人认证的登录账号为商家名称), 密码为联系人手机号</p>
    </div>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item label="保证金" v-if="formType==='margin'  " prop="marginAmount" >
        <a-input-number disabled v-model="form.marginAmount" :maxLength="8" :min="0" :max="99999999" :step="0.01"  :placeholder="$t('请输入')+'保证金'"/>
      </a-form-model-item>
      <a-form-model-item label="服务费" v-if="formType==='renewal'  " prop="serviceAmount" >
        <a-input-number disabled v-model="form.serviceAmount" :maxLength="8" :min="0" :max="99999999" :step="0.01"  :placeholder="$t('请输入')+'保证金'"/>
      </a-form-model-item>
      <a-form-model-item label="打款凭证" v-if="formType==='margin' || formType==='renewal'  " prop="paymentImg" >
        <oss-upload-single v-model="form.paymentImg" :disabled="true" prefix="merchant" type="img"/>
      </a-form-model-item>
      <a-form-model-item label="打款备注" v-if="formType==='margin' || formType==='renewal' " prop="remark" >
        <a-input  disabled v-model="form.remark"/>
      </a-form-model-item>
      <a-form-model-item label="是否同意" prop="isPass" >
        <a-radio-group v-model="form.isPass" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="保证金" v-if="formType==='merchant' && form.isPass" prop="marginAmount" >
        <a-input-number v-model="form.marginAmount" :maxLength="8" :min="0" :max="99999999" :step="0.01"  :placeholder="$t('请输入')+'保证金'"/>
      </a-form-model-item>
      <a-form-model-item label="平台抽成" v-if="formType==='margin' && form.isPass" prop="platformRate" >
        <a-input-number v-model="form.platformRate" :maxLength="8" :min="0" :max="200" :placeholder="$t('请输入')+'平台抽成'"/>
        <span>% (百分)</span>
      </a-form-model-item>
      <a-form-model-item v-if="!form.isPass" label="拒绝原因" prop="failReason" >
        <a-textarea v-model="form.failReason" :maxLength="200" :placeholder="$t('请输入')+'拒绝原因'" />
      </a-form-model-item>
      <div v-if="errorMessage">
        审核结果:   {{ errorMessage}}
      </div>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitMarginForm" v-if="formType==='margin' || formType==='renewal' " >
            {{$t('确定')}}
          </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitMerchantForm" v-if="formType==='merchant' " >
            {{$t('确定')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import {merchantAudit, marginAudit, getMerchantApply} from '@/api/merchant/merchantApply'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import {getId, getMerchantMerchant} from "@/api/merchant/merchantMerchant";
import {getBusinessType} from "@/api/merchant/businessType";


export default {
  name: 'AuditForm',
  props: {
  },
  components: {
    OssUploadSingle,
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      record: {
        id:null,
      } ,
      errorMessage: null,
      // 表单参数
      form: {
        id: null,
        platformRate: 0,
        marginAmount:0,
        serviceAmount: 0,
        isPass:null,
        failReason:null,
        remark: null,
        paymentImg: null,
      },
      formType: '',
      open: false,
      rules: {
        isPass: [
          { required: true, message: '是否同意'+this.$t('不能为空'), trigger: 'blur' }
        ],
        marginAmount: [
          { required: true, message: '保证金'+this.$t('不能为空'), trigger: 'blur' }
        ],
        failReason: [
          { required: true, message: '拒绝原因'+this.$t('不能为空'), trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.errorMessage = null,
      this.formType = 1
      this.record={
        id:null,
      }
      this.form = {
        id: null,
        platformRate: 0,
        marginAmount:0,
        serviceAmount: 0,
        isPass:true,
        failReason:null,
        remark: null,
        paymentImg: null,
      }

    },
    /** 修改按钮操作 */
    handleAudit(id ,type) {
      this.reset()
      this.formType = type
      this.form.id= id
      this.open = true
      if (type==='margin') {
        //查询保证金信息
        getMerchantApply({"id":id}).then(response => {
          if (response.data.merchantId) {
            getMerchantMerchant({"id":response.data.merchantId}).then(daresponse =>{
              this.form.platformRate = daresponse.data.platformRate
            })
          } else {
            getBusinessType({"id":response.data.businessType}).then(daresponse =>{
              this.form.platformRate = daresponse.data.rate
            })
          }
          this.form.paymentImg = response.data.paymentImg;
          this.form.marginAmount = response.data.marginAmount
          this.form.remark = response.data.remark
        })
        this.formTitle = '保证金审核';
      } else if (type === 'renewal') {
        getMerchantApply({"id":id}).then(response => {
          this.form.paymentImg = response.data.paymentImg;
          this.form.serviceAmount = response.data.serviceAmount;
          this.form.remark = response.data.remark
        })
        this.formTitle = '续费审核';
      } else {
        getMerchantApply({"id": id}).then(response => {
          this.form.marginAmount = response.data.marginAmount
        });
        this.formTitle = '商家审核';
      }
    },
    /** 提交按钮 */
    submitMarginForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message= '审核成功'
          marginAudit(this.form).then(response => {
            if (response.code==='20001') {
              if (response.data) {
                message = response.data;
                this.errorMessage = message
              }
              this.$message.success(
                message,
                3
              );
              if (!response.data) {
                this.open = false;
                this.$emit('ok')
              }
            }
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    },
    submitMerchantForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message= '审核成功'
          merchantAudit(this.form).then(response => {
            if (response.code==='20001') {
              if (response.data) {
                message = response.data;
                this.errorMessage = message
              }
              this.$message.success(
                message,
                3
              );
              if (!response.data) {
                this.open = false;
                this.$emit('ok')
              }
            }
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style  lang="less" scoped>
.info-table {
  tr {
    height: 50px;
  }
  td {
    display: table-cell;
    vertical-align: top;
    font-size: 16px;
  }
  .first {
    width: 120px;
  }
  .data {
    width: 280px;
  }
}
</style>
